import axios from '@lib/axios';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface Inputs {
  ids: string[];
}

interface Props {
  resourceName: string;
	onSuccess?: () => void;
  onError?: (res: AxiosError) => void;
}

export const useSortItems = ({
  resourceName,
	onSuccess,
  onError
}: Props) => {
	const {
		mutate: onSortItems,
    ...rest
	} = useMutation({
		mutationFn: async (data: Inputs) => axios.post(`/${resourceName}/sort`, data),
		onSuccess,
    onError
	});

	return { onSortItems, ...rest };
};
